import $ from 'jquery';

let $youtube = $('.youtube__overlay');
const popupClass = 'youtube__overlay--popup';

$youtube.on('click', ev => {
    ev.preventDefault();
    let $parent = $(ev.currentTarget).parents('.youtube').first();
    let $iframe = $($parent.find('*[data-embed-code]').attr('data-embed-code'));

    if($(ev.currentTarget).hasClass(popupClass)) {
        $.magnificPopup.open({
            items: {
                src: $iframe.attr('src')
            },
            type: 'iframe',
            fixedContentPos: true,
        });
    } else {
        $iframe.attr('allowfullscreen', '');
        $parent.html('');
        $parent.append($iframe);
    }
});

consentApi.on('enable:youtube', _ => {
    $youtube.each(function () {
        if(!$(this).hasClass(popupClass)) {
            $youtube.trigger('click');
        }
    })
});
